import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}crm/pipelines`;

export default {
  list(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  get(id) {
    return axios.get(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}/${id}`, data, { headers: buildHeaders() });
  },
  remove(id) {
    return axios.delete(`${API_URL}/${id}`, { headers: buildHeaders() });
  },
};
